export default __webpack_public_path__ + "static/media/upload-ic.810766e3.svg";